import { get as _get } from "lodash";
import api from "../../helpers/api";

export const getCompetitiveAnalysisList = (variables) => {
  return api().options("/client/competitive_analysis_list", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Competitive Analysis reports fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching competitive analysis list."),
      data: {},
    };
  });
};

export const deleteCompetitiveAnalysis = (analysisId) => {
  return api().delete(`/client/competitive_analysis/${(analysisId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Competitive Analysis report deleted successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting competitive analysis."),
      data: {},
    };
  });
};

export const getCompetitiveAnalysisCron = (analysisId) => {
  return api().get(`/client/competitive_analysis/${(analysisId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Competitive Analysis report details fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching competitive analysis details."),
      data: {},
    };
  });
};

export const saveCompetitiveAnalysis = (variables) => {
  return api().post("/client/save_competitive_analysis", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Competitive Analysis report saved successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while saving competitive analysis."),
      data: {},
    };
  });
};

export const getCompetitiveAnalysisReport = (analysisId) => {
  return api().get(`/client/get_competitive_analysis_report/${(analysisId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Competitive Analysis report fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching competitive analysis report."),
      data: {},
    };
  });
};
